import { render, staticRenderFns } from "./SpaceManage.vue?vue&type=template&id=66a7d433&scoped=true"
import script from "./SpaceManage.vue?vue&type=script&lang=js"
export * from "./SpaceManage.vue?vue&type=script&lang=js"
import style0 from "./SpaceManage.vue?vue&type=style&index=0&id=66a7d433&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a7d433",
  null
  
)

export default component.exports